import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MantantRoutingModule} from './mandant-routing.module'
import { AppMaterialModule } from 'src/app/helpers/app-material.module';
import { BaseComponent } from './base/base.component';
import { LegalComponent } from './legal/legal.component';
import { ParamsComponent } from './params/params.component';
import { ServicesComponent } from './services/services.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
;
import { SharedPipesModule} from '../../../../pipes/shared-pipes.module'
import { TranslateStateModule } from 'src/app/pipes/translate-state.module';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
  declarations: [
    BaseComponent,
    LegalComponent,
    ParamsComponent,
    ServicesComponent
  ],
  imports: [
    CommonModule,
    MantantRoutingModule,
    AppMaterialModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedPipesModule,
    TranslateStateModule,
    SharedPipesModule,
    CKEditorModule
    ]
})
export class MandantModule { }
